// /* eslint-disable jsx-a11y/anchor-is-valid */
import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { DateFormatNew } from '../../../constants/date-picker-constant';
import { NCReportFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { INCReportFilter } from '../../../models/INonconformanceReportFilter';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import {
  ClearFilterIcon,
  CloseFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import { DateRangeFilterValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: INCReportFilter;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
}

const NCReportFilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if (!isOpen) {
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }

  return (
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={DateRangeFilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: INCReportFilter, { resetForm }) => {
          if (values.StartDate === null) values.StartDate = '';
          if (values.EndDate === null) values.EndDate = '';

          if (values.StartDate) {
            values = {
              ...values,
              StartDate: `${getLocalISODate(
                new Date(values.StartDate)
              ).slice(0, 10)}`,
            };
          }

          if (values.EndDate) {
            values = {
              ...values,
              EndDate: `${getLocalISODate(
                new Date(values.EndDate)
              ).slice(0, 10)}`,
            };
          }

          props.submitHandler(values);
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values, errors, touched, setFieldTouched }) => {
          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      resetForm();
                      setShowDropdown(!showDropdown);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <CloseFilterIcon />
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="start_date"
                              htmlFor="StartDate"
                            />
                            <Field
                              data-testid="StartDate"
                              className="form-control"
                              name="StartDate"
                              autoComplete="off"
                              placeholder=""
                              dateFormat={DateFormatNew}
                              as={FormikFormDatePicker}
                              isClearable={values.StartDate}
                              maxDate={values.EndDate ? new Date(values.EndDate) : undefined}
                              onBlur={() => setFieldTouched('StartDate', true, true)}
                            />
                            {/* {touched.StartDate && errors.StartDate && (
                              <span className='text-danger errorMessage'>
                                {formatMessage(errors.StartDate as string)}
                              </span>
                            )} */}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_date"
                              htmlFor="EndDate"
                            />
                            <Field
                              data-testid="EndDate"
                              className="form-control"
                              name="EndDate"
                              autoComplete="off"
                              placeholder=""
                              dateFormat={DateFormatNew}
                              as={FormikFormDatePicker}
                              isClearable={values.EndDate}
                              minDate={values.StartDate ? new Date(values.StartDate) : undefined}
                              onBlur={() => setFieldTouched('EndDate', true, true)}
                            />
                            {touched.EndDate && errors.EndDate && (
                              <span className='text-danger errorMessage'>
                                {formatMessage(errors.EndDate as string)}
                              </span>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                    <div
                      style={{
                        visibility: props.isFilterCleared
                          ? 'hidden'
                          : 'visible',
                      }}
                    >
                      <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(NCReportFilterInitialState, true);
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                      </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={
                        JSON.stringify(props.initialValues) === 
                        JSON.stringify(values)
                      }
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
  );
};

export default NCReportFilterComponent;